import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography, useTheme } from '@mui/material';
import {
  RadioButtonChecked as CircularIcon,
  ShowChart as BarIcon,
  ShowChartOutlined as BarScoreIcon
} from '@mui/icons-material';

function DisplayModeSwitch({ value, onChange }) {
  const theme = useTheme();

  const handleChange = (event, newValue) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
      <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
        Display Mode:
      </Typography>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={handleChange}
        size="small"
        sx={{
          '& .MuiToggleButton-root': {
            px: 2,
            py: 0.5,
            fontSize: '0.75rem',
            textTransform: 'none',
          },
        }}
      >
        <ToggleButton value="circular" aria-label="circular">
          <CircularIcon sx={{ fontSize: 16, mr: 0.5 }} />
          Circular
        </ToggleButton>
        <ToggleButton value="bar-only" aria-label="bar only">
          <BarIcon sx={{ fontSize: 16, mr: 0.5 }} />
          Bar Only
        </ToggleButton>
        <ToggleButton value="bar-with-score" aria-label="bar with score">
          <BarScoreIcon sx={{ fontSize: 16, mr: 0.5 }} />
          Bar + Score
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

export default DisplayModeSwitch; 